import { render, staticRenderFns } from "./RgpdConfig.vue?vue&type=template&id=1d76b184&scoped=true"
import script from "./RgpdConfig.vue?vue&type=script&lang=js"
export * from "./RgpdConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d76b184",
  null
  
)

export default component.exports